import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { useGetRoleByIdQuery } from "./redux/api";
import { setPermission } from "./redux/reducer";

export const PrivateRoute = ({ element, pageType, requiredPermissions = null }) => {
  const dispatch = useDispatch();
  // Read live from the store rather than freezing localStorage in a ref at
  // mount: the ref kept a stale roleId alive after a logout wiped storage, so
  // this component went on requesting /v1/roles/<old id> with no token.
  const { token, user, permissions: storedPermissions } = useSelector((state) => state.app);
  const roleId = user?.roleId;

  // api call -----------------------------------------------------------------
  // Hooks cannot be conditional, so this runs before the redirect below can
  // happen. Without `skip` every render without a session — including the one
  // that immediately bounces to /login — fired an unauthenticated request.
  const { data } = useGetRoleByIdQuery(roleId, { skip: !token || !roleId });

  const permissions = data?.result?.[0]?.permissions ?? storedPermissions;

  // Dispatching during render (as this used to) re-enters the component while
  // React is still rendering it.
  useEffect(() => {
    const rolePermissions = data?.result?.[0]?.permissions;
    if (rolePermissions) dispatch(setPermission(rolePermissions));
  }, [data, dispatch]);

  if (!token) return <Navigate to="/login" />;
  if (!requiredPermissions) return element;
  return permissions?.[pageType]?.[requiredPermissions] == 1 ? element : <></>;
};
